import React, { useCallback } from "react";

import Group from "antd/es/radio/group";
import { RadioGroupProps as AntdRadioGroupProps, RadioChangeEvent } from "antd/es/radio/interface";
import cn from "classnames";

import { Labeled, LabeledProps } from "@mapmycustomers/ui";

import styles from "./RadioGroup.module.scss";

export interface RadioGroupProps<T>
  extends
    Omit<AntdRadioGroupProps, "onChange" | "value">,
    Pick<LabeledProps, "label" | "required"> {
  className?: string;
  onChange?: (value: T, event: RadioChangeEvent) => void;
  value?: T;
  vertical?: boolean;
}

const RadioGroup = <T = string,>({
  buttonStyle = "solid",
  children,
  className,
  label,
  onChange,
  required,
  vertical,
  ...props
}: RadioGroupProps<T>) => {
  const handleChange = useCallback(
    (event: RadioChangeEvent) => onChange && onChange(event.target.value, event),
    [onChange]
  );

  return (
    <Labeled label={label} required={required}>
      <Group
        buttonStyle={buttonStyle}
        className={cn(className, { [styles.vertical]: vertical })}
        onChange={handleChange}
        {...props}
      >
        {children}
      </Group>
    </Labeled>
  );
};

export default RadioGroup;
